import React, { useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import ScrollReveal from '../ScrollReveal';
import '../../css/Hero.css';

const Hero = () => {
  useEffect(() => {
    // Initialize particles.js only once
    if (!window.particlesJS) {
      return;
    }

    // Destroy any existing particles instance
    if (window.pJSDom && window.pJSDom.length > 0) {
      window.pJSDom.forEach((pJSDomItem) => {
        pJSDomItem.pJS.fn.vendors.destroypJS();
        pJSDomItem.pJS = null;
      });
      window.pJSDom = [];
    }

    // Remove any existing canvas
    const existingCanvas = document.querySelector('#particles-js canvas');
    if (existingCanvas) {
      existingCanvas.remove();
    }

    // Initialize new particles instance
    window.particlesJS('particles-js', {
      particles: {
        number: {
          value: 80,
          density: {
            enable: true,
            value_area: 800
          }
        },
        color: {
          value: '#ffffff'
        },
        shape: {
          type: 'circle'
        },
        opacity: {
          value: 0.5,
          random: true,
          anim: {
            enable: true,
            speed: 1,
            opacity_min: 0.1,
            sync: false
          }
        },
        size: {
          value: 3,
          random: true,
          anim: {
            enable: true,
            speed: 2,
            size_min: 0.1,
            sync: false
          }
        },
        line_linked: {
          enable: true,
          distance: 150,
          color: '#ffffff',
          opacity: 0.2,
          width: 1
        },
        move: {
          enable: true,
          speed: 2,
          direction: 'none',
          random: true,
          straight: false,
          out_mode: 'out',
          bounce: false,
          attract: {
            enable: false,
            rotateX: 600,
            rotateY: 1200
          }
        }
      },
      interactivity: {
        detect_on: 'canvas',
        events: {
          onhover: {
            enable: true,
            mode: 'repulse'
          },
          onclick: {
            enable: true,
            mode: 'push'
          },
          resize: true
        },
        modes: {
          repulse: {
            distance: 100,
            duration: 0.4
          },
          push: {
            particles_nb: 4
          }
        }
      },
      retina_detect: true
    });

    // Cleanup function
    return () => {
      if (window.pJSDom && window.pJSDom.length > 0) {
        window.pJSDom.forEach((pJSDomItem) => {
          if (pJSDomItem.pJS && pJSDomItem.pJS.fn) {
            pJSDomItem.pJS.fn.vendors.destroypJS();
          }
        });
        window.pJSDom = [];
      }
      const canvas = document.querySelector('#particles-js canvas');
      if (canvas) {
        canvas.remove();
      }
    };
  }, []);

  return (
    <section className="fd-hero-section">
      {/* Particles.js Background */}
      <div id="particles-js" className="fd-particles-container"></div>

      {/* Main Content - With ScrollReveal animations */}
      <Container fluid className="fd-content-wrapper">
        <ScrollReveal threshold={0.01} delay={0} direction="up">
          <Row className="align-items-center justify-content-left ms-3">
            <Col lg={8} md={12} className="text-center text-lg-start">
              {/* Main Title */}
              <h1 className="fd-main-title mt-3">
                Streamline Your Help
                <br />
                Desk Operations with{' '}
                <br />
                <span className="fd-highlight-brand">FrothDesk</span>
              </h1>

              {/* Description */}
              <p className="fd-description-text mt-2">
                Eliminate the oversight of inquiries and the redundancy of responses,
                streamlining the communication process and enhancing the transparency
                of information flows.
              </p>

            
            </Col>
          </Row>
        </ScrollReveal>
      </Container>

      {/* Wave Bottom */}
      <div className="fd-wave-container">
        <div className="fd-wave">
          <svg viewBox="0 0 1440 150" preserveAspectRatio="none">
            <path
              d="M0,50 C360,150 1080,0 1440,50 L1440,150 L0,150 Z"
              fill="rgba(0, 51, 102, 0.8)"
            />
          </svg>
        </div>
      </div>
    </section>
  );
};

export default Hero;
